import React from 'react';
import { useMaintenanceStore } from '../../store/maintenanceStore';
import MaintenancePage from '../MaintenancePage';

const MaintenanceWrapper = ({ children }) => {
  const { isUnderMaintenance } = useMaintenanceStore();
  
  if (isUnderMaintenance) {
    return <MaintenancePage />;
  }
  
  return children;
};

export default MaintenanceWrapper; 